/* Mebblo Product Finder – v11.3 (ohne Rabattcode)
   - DE/EN, modernes Layout
   - Kein Newsletter
   - KEINE Sony SC5/SC7/SC55/SC100 Sonderlogik (entfernt)
   - Tapeless vor Kassette
   - NACH Tapeless-Auswahl (bei "Ja, ich habe einen Camcorder"):
     -> Budget vs Standard Bundle (MiniDVR vs ImmersionRC PowerPlay)
   - Nur TRRS → Tapeless-Bundles
   - 2x/3x RCA, S-Video, Sony 10-Pin → Hinweis „noch nicht unterstützt“
   - Kein Kassettendeck/CD-Fach → Hinweis „Camcorder schon tapeless“
   - Extras (Fisheye, microSD 32 GB, Hard Case) als eigene Fragen mit Bildern & Preis
   - Extras im letzten Schritt per Checkbox mit Preis an/abwählbar
   - KEINE Rabatt-Anzeige und KEIN Discount-Code-Redirect
*/

(function () {
  // ----------------- DESIGN / STYLES -----------------
  let stylesInjected = false;

  function injectStylesOnce() {
    if (stylesInjected) return;
    stylesInjected = true;

    const css = `
      .mpf-app {
        max-width: 960px;
        margin: 40px auto;
        padding: 28px 24px;
        background: #ffffff;
        border-radius: 18px;
        box-shadow: 0 20px 50px rgba(0,0,0,0.06);
        box-sizing: border-box;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif;
        font-size: 1rem;
      }

      @media (max-width: 768px) {
        .mpf-app {
          margin: 24px 12px;
          padding: 20px 16px;
          border-radius: 14px;
        }
      }

      .mpf-lang-toggle {
        display: flex;
        justify-content: flex-end;
        gap: 6px;
        margin-bottom: 12px;
      }

      .mpf-lang-btn {
        border-radius: 999px;
        border: 1px solid #d0d0d0;
        background: #f5f5f5;
        padding: 6px 12px;
        font-size: 0.9rem;
        cursor: pointer;
        line-height: 1;
      }

      .mpf-lang-btn.active {
        background: #000;
        color: #fff;
        border-color: #000;
      }

      .mpf-step,
      .mpf-result {
        display: flex;
        flex-direction: column;
        gap: 22px;
      }

      .mpf-title {
        font-size: 1.9rem;
        line-height: 1.3;
        font-weight: 680;
        margin: 0 0 8px;
        text-align: left;
      }

      .mpf-note {
        font-size: 1.08rem;
        line-height: 1.6;
        color: #444;
      }

      .mpf-options {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
        gap: 18px;
        margin-top: 4px;
      }

      .mpf-option {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        text-align: left;
        gap: 10px;
        padding: 16px 18px 14px;
        background: #f7f7f7;
        border-radius: 12px;
        border: 1px solid transparent;
        cursor: pointer;
        transition: all 0.18s ease-out;
        font-size: 1.12rem;
      }

      .mpf-option span {
        font-weight: 600;
        display: block;
        font-size: 1.16rem;
      }

      .mpf-option:hover {
        background: #f0f0f0;
        border-color: #111;
        transform: translateY(-1px);
      }

      .mpf-option:active {
        transform: translateY(0);
      }

      .mpf-option.mpf-option-primary {
        background: #000;
        color: #fff;
        border-color: #000;
      }

      .mpf-option.mpf-option-primary:hover {
        background: #111;
      }

      .mpf-option.mpf-option-primary .mpf-info {
        color: #e5e5e5;
      }

      .mpf-option-img {
        width: 100%;
        max-height: 200px;
        object-fit: contain;
        border-radius: 10px;
        background: #ffffff;
      }

      .mpf-info {
        font-size: 0.98rem;
        color: #555;
        line-height: 1.4;
      }

      .mpf-actions {
        margin-top: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      .mpf-back,
      .mpf-restart {
        padding: 8px 16px;
        border-radius: 999px;
        border: 1px solid #ddd;
        background: #fafafa;
        cursor: pointer;
        font-size: 0.98rem;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        white-space: nowrap;
      }

      .mpf-back:hover,
      .mpf-restart:hover {
        background: #f0f0f0;
      }

      .mpf-restart.result-restart {
        margin-top: 16px;
      }

      .mpf-products {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 12px;
      }

      .mpf-product {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 11px 13px;
        border-radius: 12px;
        background: #f7f7f7;
      }

      .mpf-product-img {
        width: 76px;
        height: 76px;
        object-fit: contain;
        border-radius: 8px;
        background: #ffffff;
        flex-shrink: 0;
      }

      .mpf-product-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .mpf-product-title {
        font-size: 1.02rem;
        font-weight: 500;
      }

      .mpf-product-price {
        font-size: 0.98rem;
        color: #555;
      }

      .mpf-pricing {
        margin-top: 14px;
        padding-top: 10px;
        border-top: 1px solid #eee;
        font-size: 1.02rem;
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .mpf-final {
        font-weight: 680;
        font-size: 1.12rem;
      }

      .mpf-addcart {
        margin-top: 18px;
        padding: 12px 24px;
        border-radius: 999px;
        border: none;
        background: #000000;
        color: #ffffff;
        font-size: 1.02rem;
        font-weight: 540;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .mpf-addcart:hover {
        opacity: 0.9;
      }

      /* Mount-Farbwahl */
      .mpf-color-block {
        margin-top: 16px;
      }

      .mpf-color-title {
        font-size: 1.05rem;
        font-weight: 560;
        margin-bottom: 8px;
      }

      .mpf-color-options {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      .mpf-color-option {
        padding: 7px 12px;
        border-radius: 999px;
        border: 1px solid #d0d0d0;
        background: #fafafa;
        cursor: pointer;
        font-size: 0.98rem;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        position: relative;
      }

      .mpf-color-option::before {
        content: "";
        width: 16px;
        height: 16px;
        border-radius: 999px;
        background: var(--pill-color, #000);
        box-shadow: inset 0 0 0 1px rgba(255,255,255,0.7);
        flex-shrink: 0;
      }

      .mpf-color-option.selected {
        background: #fff;
        border-color: #000;
      }

      /* Info-Bilder */
      .mpf-info-images {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin: 4px 0 12px;
      }

      .mpf-info-img {
        width: 160px;
        height: auto;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fafafa;
        object-fit: cover;
      }

      /* Extras im letzten Schritt */
      .mpf-addon-block {
        margin-top: 18px;
      }

      .mpf-addon-heading {
        font-size: 1.05rem;
        font-weight: 560;
        margin-bottom: 6px;
      }

      .mpf-addon-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
        font-size: 0.98rem;
      }

      .mpf-addon-row input[type="checkbox"] {
        flex-shrink: 0;
      }
    `;

    const styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.appendChild(document.createTextNode(css));
    document.head.appendChild(styleEl);
  }

  // ----------------- HILFSFUNKTIONEN -----------------

  function formatMoneyFromCents(cents) {
    const cur =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: cur,
      }).format((cents || 0) / 100);
    } catch {
      return ((cents || 0) / 100).toFixed(2) + " " + cur;
    }
  }

  function getProduct(handle) {
    const map = window.__MPF_PRODUCTMAP__ || {};
    const sectionMap =
      (window.__MPF_PRODUCTMAP__ &&
        App.sectionId &&
        window.__MPF_PRODUCTMAP__[App.sectionId]) ||
      {};
    return sectionMap[handle] || map[handle] || null;
  }

  const MTO_NOTE_DE =
    "Kabel wird auf Bestellung gefertigt; Produktionszeit ca. 30 Tage.";
  const MTO_NOTE_EN =
    "Cable is made to order; production time approx. 30 days.";

  const MOUNT_COLORS = [
    { key: "black", hex: "#111111", labelDe: "Schwarz", labelEn: "Black" },
    {
      key: "transparent",
      hex: "#e5e5e5",
      labelDe: "Transparent",
      labelEn: "Clear (translucent)",
    },
    { key: "blue", hex: "#0045c6", labelDe: "Blau", labelEn: "Blue" },
    {
      key: "green",
      hex: "#14502c",
      labelDe: "Waldgrün",
      labelEn: "Forest green",
    },
    { key: "red", hex: "#e02424", labelDe: "Rot", labelEn: "Red" },
    { key: "yellow", hex: "#ffd500", labelDe: "Gelb", labelEn: "Yellow" },
    { key: "orange", hex: "#ff6a00", labelDe: "Orange", labelEn: "Orange" },
    { key: "grey", hex: "#b3b3b3", labelDe: "Grau", labelEn: "Grey" },
  ];

  // ----------------- FLOWS (DE / EN) -----------------

  const FLOWS = {
    de: {
      start: "q1",
      questions: {
        q1: {
          text: "Besitzt du einen Camcorder?",
          options: [
            { id: "cam_yes", label: "Ja, ich habe einen Camcorder", next: "q2" },
            {
              id: "cam_no",
              label: "Nein, ich habe noch keinen",
              next: "q_cam_select",
              tags: ["no_camcorder"],
            },
          ],
        },

        q_cam_select: {
          text: "Welchen Camcorder möchtest du auswählen?",
          options: [
            {
              id: "pick_pc110",
              label: "Sony DCR-PC110E",
              next: "q_bundle_pick",
              tags: ["pick_pc110", "cam_auto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG-0025.png?v=1757625004",
            },
            {
              id: "pick_pc100",
              label: "Sony DCR-PC100E",
              next: "q_bundle_pick",
              tags: ["pick_pc100", "cam_auto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG-0023.png?v=1757624876",
            },
          ],
        },

        // Bundle Pick (für "kein Camcorder" Flow)
        q_bundle_pick: {
          text: "Welche Ausstattung möchtest du?",
          options: [
            {
              id: "bundle_budget",
              label: "Budget (MiniDVR-Bundle)",
              info:
                "Günstigste Lösung. Video wird gut aufgezeichnet, Audio jedoch nur in schlechter Qualität. Empfehlenswert, wenn dir Ton nicht wichtig ist. Eine spätere Aufrüstung ist jederzeit möglich.",
              next: "q_add_fisheye",
              tags: ["bundle_budget"],
            },
            {
              id: "bundle_standard",
              label: "Standard (PowerPlay-Bundle)",
              info:
                "Zusätzlicher externer Bildschirm für Playback. Höchste Qualität und nutzbares Audio. Nachteil: höherer Preis.",
              next: "q_add_fisheye",
              tags: ["bundle_standard"],
            },
          ],
        },

        q2: {
          text: "Hat dein Camcorder ein Kassetten- oder CD-Fach?",
          options: [
            { id: "tape_yes", label: "Ja", next: "q3", tags: ["tape_yes"] },
            { id: "tape_no", label: "Nein", next: "result", tags: ["tape_no"] },
          ],
        },

        q3: {
          text: "Wie willst du deine Aufnahmen machen?",
          options: [
            {
              id: "rec_sd",
              label: "Ohne Kassette (direkt tapeless)",
              next: "q_bundle_pick_existing",
              tags: ["record_sd"],
              primary: true,
            },
            {
              id: "rec_tape",
              label: "Mit Kassette (später digitalisieren)",
              next: "result",
              tags: ["record_tape"],
            },
          ],
        },

        // Bundle-Auswahl NACH Tapeless (bei "ich habe einen Camcorder")
        q_bundle_pick_existing: {
          text: "Welches Tapeless-Bundle möchtest du?",
          options: [
            {
              id: "bundle_budget",
              label: "Budget (MiniDVR)",
              info:
                "Günstigste Lösung. Video ist gut, aber Audio ist meist nur in schlechter Qualität / oft nicht wirklich nutzbar. Perfekt, wenn du vor allem Bild willst.",
              next: "q4",
              tags: ["bundle_budget"],
            },
            {
              id: "bundle_standard",
              label: "Standard (ImmersionRC PowerPlay)",
              info:
                "Beste Lösung. PowerPlay liefert die höchste Qualität + nutzbares Audio und hat einen Screen für Playback. Nachteil: teurer.",
              next: "q4",
              tags: ["bundle_standard"],
            },
          ],
        },

        q4: {
          text: "Welche Anschlüsse hat dein Camcorder?",
          options: [
            {
              id: "av35",
              label: "A/V 3,5 mm (TRRS)",
              next: "q5",
              tags: ["anschluss_av35"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-03.png?v=1757542873",
            },
            {
              id: "cinch2",
              label: "2× Cinch",
              next: "result",
              tags: ["anschluss_cinch2", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-02.png?v=1757539752",
            },
            {
              id: "cinch3",
              label: "3× Cinch",
              next: "result",
              tags: ["anschluss_cinch3", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-01.png?v=1757539753",
            },
            {
              id: "sony10",
              label: "Sony 10-Pin",
              next: "result",
              tags: ["anschluss_sony10", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-05.png?v=1764586505",
            },
            {
              id: "svideo",
              label: "S-Video",
              next: "result",
              tags: ["anschluss_svideo", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-04.png?v=1757542873",
            },
            {
              id: "unknown_output",
              label: "Weiß ich nicht",
              next: "result",
              tags: ["anschluss_unbekannt"],
            },
          ],
        },

        q5: {
          text: "Hat dein Camcorder einen Blitzschuh (Zubehörschuh)?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_cold-shoe_1080x1080_01-01.png?v=1764782822",
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_cold-shoe_1080x1080_01-02.png?v=1764782822",
          ],
          options: [
            {
              id: "hotshoe_yes",
              label: "Ja",
              next: "q_add_fisheye",
              tags: ["blitzschuh"],
            },
            {
              id: "hotshoe_no",
              label: "Nein",
              next: "q_add_fisheye",
              tags: ["no_sc"], // <- wir nutzen "no_sc" einfach als "kein Blitzschuh"-Tag (für Extension Bracket Outcomes)
            },
          ],
        },

        // --------- Extras (mit Bildern) ---------

        q_add_fisheye: {
          text: "Möchtest du ein Fisheye 0,25x für 37 mm Filtergewinde hinzufügen?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG_0002.jpg?v=1757609367",
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_minidvr_mount_black_02.jpg?v=1764783537",
          ],
          options: [
            {
              id: "fisheye_yes",
              label: "Ja, Fisheye hinzufügen",
              next: "q_add_microsd",
            },
            {
              id: "fisheye_no",
              label: "Nein, ohne Fisheye",
              next: "q_add_microsd",
            },
          ],
        },

        q_add_microsd: {
          text: "Brauchst du eine 32 GB microSD-Karte?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_microsd-card_32gb_kodak_01.png?v=1765062505",
          ],
          options: [
            {
              id: "microsd_yes",
              label: "Ja, 32 GB microSD hinzufügen",
              next: "q_add_hardcase",
            },
            {
              id: "microsd_no",
              label: "Nein, ich habe bereits eine Karte",
              next: "q_add_hardcase",
            },
          ],
        },

        q_add_hardcase: {
          text: "Möchtest du ein Hard Case für dein Camcorder-Setup?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_camcorder_hard-case_01.jpg?v=1765015027",
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG_2482.heic?v=1765056536",
          ],
          options: [
            {
              id: "hardcase_yes",
              label: "Ja, Hard Case hinzufügen",
              next: "result",
            },
            {
              id: "hardcase_no",
              label: "Nein, ohne Hard Case",
              next: "result",
            },
          ],
        },
      },

      // --------- Outcomes DE ---------
      outcomes: [
        {
          id: "cassette_notice",
          title: "Aufnahme auf Kassette – benötigtes Zubehör",
          when: { hasAll: ["record_tape"] },
          products: [],
          note: `
            Wir bieten zurzeit leider keine Kassetten an.<br>
            Bei Fragen kontaktiere uns gern.
            <br><br>
            <a href="https://mebblo.com/pages/contact"
               style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
              Kontakt aufnehmen
            </a>
            <br><br>
            oder via Instagram: @mebblo.camcorder
          `,
        },

        // --- "Kein Camcorder" Bundles
        {
          id: "bundle_no_camcorder_budget_pc110",
          title: "MiniDVR – Budget Bundle (PC110E)",
          when: { hasAll: ["no_camcorder", "bundle_budget", "pick_pc110"] },
          products: [
            { key: "camcorder_sony-dcr-pc-110e_01", qty: 1 },
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "minidvr_mount_cold-shoe", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note:
            "Preiswerte Einstiegslösung: Video gut, Audio nur in schlechter Qualität. Aufrüstung später möglich.",
        },
        {
          id: "bundle_no_camcorder_budget_pc100",
          title: "MiniDVR – Budget Bundle (PC100E)",
          when: { hasAll: ["no_camcorder", "bundle_budget", "pick_pc100"] },
          products: [
            { key: "camcorder_sony-dcr-pc-100e_01", qty: 1 },
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "minidvr_mount_cold-shoe", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note:
            "Preiswerte Einstiegslösung: Video gut, Audio nur in schlechter Qualität. Aufrüstung später möglich.",
        },
        {
          id: "bundle_no_camcorder_standard_pc110",
          title: "PowerPlay – Standard Bundle (PC110E)",
          when: { hasAll: ["no_camcorder", "bundle_standard", "pick_pc110"] },
          products: [
            { key: "camcorder_sony-dcr-pc-110e_01", qty: 1 },
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note:
            "Standard-Bundle mit nutzbarem Audio & integriertem Bildschirm für Playback.",
        },
        {
          id: "bundle_no_camcorder_standard_pc100",
          title: "PowerPlay – Standard Bundle (PC100E)",
          when: { hasAll: ["no_camcorder", "bundle_standard", "pick_pc100"] },
          products: [
            { key: "camcorder_sony-dcr-pc-100e_01", qty: 1 },
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note:
            "Standard-Bundle mit nutzbarem Audio & integriertem Bildschirm für Playback.",
        },

        // ---------------------------
        // AV35 (TRRS) outcomes abhängig von bundle (Budget/Standard)
        // ---------------------------

        // AV35 + Blitzschuh (Budget -> MiniDVR)
        {
          id: "tapeless_av35_hotshoe_budget",
          title: "Budget Tapeless-Bundle (A/V 3,5 mm + Blitzschuh)",
          when: { hasAll: ["anschluss_av35", "blitzschuh", "bundle_budget"] },
          products: [
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "minidvr_mount_cold-shoe", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note: "MiniDVR (Budget): Video gut, Audio meist nur in schlechter Qualität.",
        },

        // AV35 + Blitzschuh (Standard -> PowerPlay)
        {
          id: "tapeless_av35_hotshoe_standard",
          title: "Standard Tapeless-Bundle (A/V 3,5 mm + Blitzschuh)",
          when: { hasAll: ["anschluss_av35", "blitzschuh", "bundle_standard"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note: "PowerPlay (Standard): nutzbares Audio & Bildschirm für Playback.",
        },

        // AV35 ohne Blitzschuh (Budget -> MiniDVR + Extension Bracket)
        {
          id: "tapeless_av35_nohotshoe_budget",
          title: "Budget Tapeless-Bundle (A/V 3,5 mm – ohne Blitzschuh)",
          when: { hasAll: ["anschluss_av35", "no_sc", "bundle_budget"] },
          products: [
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "extension_bracket_generic", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note: "Für Camcorder ohne Blitzschuh: Befestigung über Extension-Bracket.",
        },

        // AV35 ohne Blitzschuh (Standard -> PowerPlay + Extension Bracket)
        {
          id: "tapeless_av35_nohotshoe_standard",
          title: "Standard Tapeless-Bundle (A/V 3,5 mm – ohne Blitzschuh)",
          when: { hasAll: ["anschluss_av35", "no_sc", "bundle_standard"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "extension_bracket_generic", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note: "Für Camcorder ohne Blitzschuh: Befestigung über Extension-Bracket.",
        },

        // ---------------------------
        // Unverändert: MTO/unsupported outcomes
        // ---------------------------
        {
          id: "tapeless_cinch2_hotshoe",
          title: "Tapeless-Bundle (2× Cinch + Blitzschuh)",
          when: { hasAll: ["anschluss_cinch2", "blitzschuh"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "cable_custom_2cinch_trrs", qty: 1 },
          ],
          note: MTO_NOTE_DE,
        },
        {
          id: "tapeless_cinch3_hotshoe",
          title: "Tapeless-Bundle (3× Cinch + Blitzschuh)",
          when: { hasAll: ["anschluss_cinch3", "blitzschuh"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "cable_custom_3cinch_trrs", qty: 1 },
          ],
          note: MTO_NOTE_DE,
        },
        {
          id: "tapeless_svideo_hotshoe",
          title: "Tapeless-Bundle (S-Video + Blitzschuh)",
          when: { hasAll: ["anschluss_svideo", "blitzschuh"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "cable_custom_svideo", qty: 1 },
          ],
          note: MTO_NOTE_DE,
        },
      ],

      fallback: {
        title: "Keine perfekte Kombination gefunden",
        note:
          "Wir haben kein exakt passendes Set gefunden. Schreib uns gern – wir empfehlen dir die passende Lösung.",
      },

      unknownConnectionOutcome: {
        title: "Anschluss unbekannt – bitte kontaktiere uns",
        note: `
          Wenn du nicht sicher bist, welchen Anschluss dein Camcorder hat, schick uns bitte ein Foto des Anschlusses oder des Camcorders.<br><br>
          <a href="https://mebblo.com/pages/contact"
             style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
            Kontaktformular öffnen
          </a>
          <br><br>
          oder via Instagram: <strong>@mebblo.camcorder</strong>
        `,
      },

      unsupportedConnectionOutcome: {
        title: "Anschluss wird noch nicht unterstützt",
        note: `
          Für 2×/3× Cinch, S-Video oder Sony 10-Pin bieten wir aktuell noch kein fertiges Tapeless-Zubehör an.<br><br>
          Schreib uns gern – oft finden wir trotzdem eine Lösung.
          <br><br>
          <a href="https://mebblo.com/pages/contact"
             style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
            Kontakt aufnehmen
          </a>
          <br><br>
          oder via Instagram: <strong>@mebblo.camcorder</strong>
        `,
      },

      noTapeOutcome: {
        title: "Dein Camcorder ist bereits tapeless",
        note: `
          Dein Camcorder hat kein Kassetten- oder CD-Fach – vermutlich nimmt er bereits direkt auf Speicherkarte oder Festplatte auf.<br><br>
          In diesem Fall ist ein zusätzliches Tapeless-Setup mit externem Recorder meist nicht nötig.<br><br>
          Wenn du unsicher bist, schreib uns gern und wir schauen gemeinsam drauf.
          <br><br>
          <a href="https://mebblo.com/pages/contact"
             style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
            Kontaktformular öffnen
          </a>
          <br><br>
          oder via Instagram: <strong>@mebblo.camcorder</strong>
        `,
      },
    },

    // ---------- ENGLISH FLOW ----------
    en: {
      start: "q1",
      questions: {
        q1: {
          text: "Do you own a camcorder?",
          options: [
            { id: "cam_yes", label: "Yes, I own a camcorder", next: "q2" },
            {
              id: "cam_no",
              label: "No, I don't have one yet",
              next: "q_cam_select",
              tags: ["no_camcorder"],
            },
          ],
        },

        q_cam_select: {
          text: "Which camcorder would you like to choose?",
          options: [
            {
              id: "pick_pc110",
              label: "Sony DCR-PC110E",
              next: "q_bundle_pick",
              tags: ["pick_pc110", "cam_auto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG-0025.png?v=1757625004",
            },
            {
              id: "pick_pc100",
              label: "Sony DCR-PC100E",
              next: "q_bundle_pick",
              tags: ["pick_pc100", "cam_auto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG-0023.png?v=1757624876",
            },
          ],
        },

        // Bundle Pick (for "no camcorder" flow)
        q_bundle_pick: {
          text: "Which setup do you prefer?",
          options: [
            {
              id: "bundle_budget",
              label: "Budget (MiniDVR bundle)",
              info:
                "Cheapest option. Video quality is good, but audio is recorded in poor quality and usually not usable. Recommended only if you mainly care about video. You can always upgrade later to get proper audio.",
              next: "q_add_fisheye",
              tags: ["bundle_budget"],
            },
            {
              id: "bundle_standard",
              label: "Standard (PowerPlay bundle)",
              info:
                "Includes an external screen for playback. Highest quality and usable audio. Downside: higher price.",
              next: "q_add_fisheye",
              tags: ["bundle_standard"],
            },
          ],
        },

        q2: {
          text: "Does your camcorder have a cassette or CD compartment?",
          options: [
            { id: "tape_yes", label: "Yes", next: "q3", tags: ["tape_yes"] },
            { id: "tape_no", label: "No", next: "result", tags: ["tape_no"] },
          ],
        },

        q3: {
          text: "How do you want to record your footage?",
          options: [
            {
              id: "rec_sd",
              label: "Without cassette (direct tapeless)",
              next: "q_bundle_pick_existing",
              tags: ["record_sd"],
              primary: true,
            },
            {
              id: "rec_tape",
              label: "With cassette (digitize later)",
              next: "result",
              tags: ["record_tape"],
            },
          ],
        },

        // Bundle selection after tapeless (existing camcorder path)
        q_bundle_pick_existing: {
          text: "Which tapeless bundle do you want?",
          options: [
            {
              id: "bundle_budget",
              label: "Budget (MiniDVR)",
              info:
                "Cheapest option. Video looks good, but audio is usually low quality / often not really usable. Great if you mainly care about image.",
              next: "q4",
              tags: ["bundle_budget"],
            },
            {
              id: "bundle_standard",
              label: "Standard (ImmersionRC PowerPlay)",
              info:
                "Best option. PowerPlay gives the highest quality + usable audio and includes a screen for playback. Downside: higher price.",
              next: "q4",
              tags: ["bundle_standard"],
            },
          ],
        },

        q4: {
          text: "Which outputs does your camcorder have?",
          options: [
            {
              id: "av35",
              label: "A/V 3.5 mm (TRRS)",
              next: "q5",
              tags: ["anschluss_av35"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-03.png?v=1757542873",
            },
            {
              id: "cinch2",
              label: "2× RCA (Cinch)",
              next: "result",
              tags: ["anschluss_cinch2", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-02.png?v=1757539752",
            },
            {
              id: "cinch3",
              label: "3× RCA (Cinch)",
              next: "result",
              tags: ["anschluss_cinch3", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-01.png?v=1757539753",
            },
            {
              id: "sony10",
              label: "Sony 10-pin",
              next: "result",
              tags: ["anschluss_sony10", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-05.png?v=1764586505",
            },
            {
              id: "svideo",
              label: "S-Video",
              next: "result",
              tags: ["anschluss_svideo", "mto"],
              image:
                "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/website_connectors_camcorder-04.png?v=1757542873",
            },
            {
              id: "unknown_output",
              label: "I don't know",
              next: "result",
              tags: ["anschluss_unbekannt"],
            },
          ],
        },

        q5: {
          text: "Does your camcorder have a hot shoe?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_cold-shoe_1080x1080_01-01.png?v=1764782822",
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_cold-shoe_1080x1080_01-02.png?v=1764782822",
          ],
          options: [
            {
              id: "hotshoe_yes",
              label: "Yes",
              next: "q_add_fisheye",
              tags: ["blitzschuh"],
            },
            {
              id: "hotshoe_no",
              label: "No",
              next: "q_add_fisheye",
              tags: ["no_sc"], // used as "no hot shoe" tag for extension bracket outcomes
            },
          ],
        },

        // Extras EN
        q_add_fisheye: {
          text: "Would you like to add a Fisheye 0.25x for 37 mm filter thread?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG_0002.jpg?v=1757609367",
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_minidvr_mount_black_02.jpg?v=1764783537",
          ],
          options: [
            {
              id: "fisheye_yes",
              label: "Yes, add Fisheye lens",
              next: "q_add_microsd",
            },
            {
              id: "fisheye_no",
              label: "No, without Fisheye",
              next: "q_add_microsd",
            },
          ],
        },

        q_add_microsd: {
          text: "Do you need a 32 GB microSD card?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_microsd-card_32gb_kodak_01.png?v=1765062505",
          ],
          options: [
            {
              id: "microsd_yes",
              label: "Yes, add 32 GB microSD",
              next: "q_add_hardcase",
            },
            {
              id: "microsd_no",
              label: "No, I already have a card",
              next: "q_add_hardcase",
            },
          ],
        },

        q_add_hardcase: {
          text: "Would you like to add a hard case for your camcorder setup?",
          infoImages: [
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/mebblo_camcorder_hard-case_01.jpg?v=1765015027",
            "https://cdn.shopify.com/s/files/1/0911/1968/1923/files/IMG_2482.heic?v=1765056536",
          ],
          options: [
            {
              id: "hardcase_yes",
              label: "Yes, add hard case",
              next: "result",
            },
            {
              id: "hardcase_no",
              label: "No, without hard case",
              next: "result",
            },
          ],
        },
      },

      outcomes: [
        {
          id: "cassette_notice",
          title: "Recording on cassette – accessories",
          when: { hasAll: ["record_tape"] },
          products: [],
          note: `
            At the moment we don't offer cassettes.<br>
            If you have any questions, feel free to contact us.
            <br><br>
            <a href="https://mebblo.com/pages/contact"
               style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
              Contact us
            </a>
            <br><br>
            or via Instagram: @mebblo.camcorder
          `,
        },

        // "no camcorder" bundles
        {
          id: "bundle_no_camcorder_budget_pc110",
          title: "MiniDVR – budget bundle (PC110E)",
          when: { hasAll: ["no_camcorder", "bundle_budget", "pick_pc110"] },
          products: [
            { key: "camcorder_sony-dcr-pc-110e_01", qty: 1 },
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "minidvr_mount_cold-shoe", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note:
            "Affordable entry-level solution: good video, poor audio quality. You can upgrade later if you need proper audio.",
        },
        {
          id: "bundle_no_camcorder_budget_pc100",
          title: "MiniDVR – budget bundle (PC100E)",
          when: { hasAll: ["no_camcorder", "bundle_budget", "pick_pc100"] },
          products: [
            { key: "camcorder_sony-dcr-pc-100e_01", qty: 1 },
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "minidvr_mount_cold-shoe", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note:
            "Affordable entry-level solution: good video, poor audio quality. You can upgrade later if you need proper audio.",
        },
        {
          id: "bundle_no_camcorder_standard_pc110",
          title: "PowerPlay – standard bundle (PC110E)",
          when: { hasAll: ["no_camcorder", "bundle_standard", "pick_pc110"] },
          products: [
            { key: "camcorder_sony-dcr-pc-110e_01", qty: 1 },
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note: "Standard bundle with usable audio and built-in screen for playback.",
        },
        {
          id: "bundle_no_camcorder_standard_pc100",
          title: "PowerPlay – standard bundle (PC100E)",
          when: { hasAll: ["no_camcorder", "bundle_standard", "pick_pc100"] },
          products: [
            { key: "camcorder_sony-dcr-pc-100e_01", qty: 1 },
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note: "Standard bundle with usable audio and built-in screen for playback.",
        },

        // AV35 outcomes depending on bundle
        {
          id: "tapeless_av35_hotshoe_budget",
          title: "Budget tapeless bundle (A/V 3.5 mm + hot shoe)",
          when: { hasAll: ["anschluss_av35", "blitzschuh", "bundle_budget"] },
          products: [
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "minidvr_mount_cold-shoe", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note: "MiniDVR (Budget): good video, but audio is usually low quality.",
        },
        {
          id: "tapeless_av35_hotshoe_standard",
          title: "Standard tapeless bundle (A/V 3.5 mm + hot shoe)",
          when: { hasAll: ["anschluss_av35", "blitzschuh", "bundle_standard"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note: "PowerPlay (Standard): usable audio + screen for playback.",
        },
        {
          id: "tapeless_av35_nohotshoe_budget",
          title: "Budget tapeless bundle (A/V 3.5 mm – no hot shoe)",
          when: { hasAll: ["anschluss_av35", "no_sc", "bundle_budget"] },
          products: [
            { key: "minidvr_device_black_01", qty: 1 },
            { key: "extension_bracket_generic", qty: 1 },
            { key: "cable_minidvr_trrs-trs", qty: 1 },
          ],
          note: "For camcorders without hot shoe: mounting via extension bracket.",
        },
        {
          id: "tapeless_av35_nohotshoe_standard",
          title: "Standard tapeless bundle (A/V 3.5 mm – no hot shoe)",
          when: { hasAll: ["anschluss_av35", "no_sc", "bundle_standard"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "extension_bracket_generic", qty: 1 },
            { key: "immersionrc_cable_trrs-trs", qty: 1 },
          ],
          note: "For camcorders without hot shoe: mounting via extension bracket.",
        },

        // MTO/unsupported outcomes
        {
          id: "tapeless_cinch2_hotshoe",
          title: "Tapeless bundle (2× RCA + hot shoe)",
          when: { hasAll: ["anschluss_cinch2", "blitzschuh"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "cable_custom_2cinch_trrs", qty: 1 },
          ],
          note: MTO_NOTE_EN,
        },
        {
          id: "tapeless_cinch3_hotshoe",
          title: "Tapeless bundle (3× RCA + hot shoe)",
          when: { hasAll: ["anschluss_cinch3", "blitzschuh"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "cable_custom_3cinch_trrs", qty: 1 },
          ],
          note: MTO_NOTE_EN,
        },
        {
          id: "tapeless_svideo_hotshoe",
          title: "Tapeless bundle (S-Video + hot shoe)",
          when: { hasAll: ["anschluss_svideo", "blitzschuh"] },
          products: [
            { key: "immersionrc_powerplay_device_black_01", qty: 1 },
            { key: "immersionrc_mount_cold-shoe", qty: 1 },
            { key: "cable_custom_svideo", qty: 1 },
          ],
          note: MTO_NOTE_EN,
        },
      ],

      fallback: {
        title: "No perfect combination found",
        note:
          "We couldn't find an exact matching set. Feel free to contact us – we’ll help you find the right solution.",
      },

      unknownConnectionOutcome: {
        title: "Unknown output – please contact us",
        note: `
          If you're not sure which output your camcorder has, please send us a photo of the connector or the camcorder.<br><br>
          <a href="https://mebblo.com/pages/contact"
             style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
            Open contact form
          </a>
          <br><br>
          or via Instagram: <strong>@mebblo.camcorder</strong>
        `,
      },

      unsupportedConnectionOutcome: {
        title: "Output not supported (yet)",
        note: `
          For 2×/3× RCA, S-Video or Sony 10-pin we currently don't offer a ready-made tapeless accessory.<br><br>
          Feel free to reach out – often we can still find a solution.
          <br><br>
          <a href="https://mebblo.com/pages/contact"
             style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
            Contact us
          </a>
          <br><br>
          or via Instagram: <strong>@mebblo.camcorder</strong>
        `,
      },

      noTapeOutcome: {
        title: "Your camcorder is already tapeless",
        note: `
          Your camcorder has no cassette or CD compartment – it probably already records directly to memory card or HDD/SSD.<br><br>
          In that case an additional external tapeless recorder usually isn't necessary.<br><br>
          If you're unsure, feel free to contact us and we'll have a look together.
          <br><br>
          <a href="https://mebblo.com/pages/contact"
             style="padding:12px 18px; background:#000; color:#fff; border-radius:6px; text-decoration:none; display:inline-block; margin-top:10px;">
            Open contact form
          </a>
          <br><br>
          or via Instagram: <strong>@mebblo.camcorder</strong>
        `,
      },
    },
  };

  let currentLang = "de";
  function getFlow() {
    return FLOWS[currentLang];
  }

  // -------------------------------------------------------
  // RENDER ENGINE
  // -------------------------------------------------------

  const App = {
    el: null,
    sectionId: null,
    state: {
      step: null,
      answers: {},
      history: [],
      mountColor: null,
      fisheye: false,
      microsd: false,
      hardCase: false,
      baseTotalCents: 0,
      fisheyePriceCents: 0,
      microsdPriceCents: 0,
      hardCasePriceCents: 0,
    },
  };

  function makeLangToggleHTML() {
    return `
      <div class="mpf-lang-toggle">
        <button class="mpf-lang-btn ${currentLang === "de" ? "active" : ""}" data-lang="de">DE</button>
        <button class="mpf-lang-btn ${currentLang === "en" ? "active" : ""}" data-lang="en">EN</button>
      </div>
    `;
  }

  function renderQuestion(id) {
    const flow = getFlow();
    const q = flow.questions[id];
    if (!q) return renderResult();

    App.state.step = id;

    let html = makeLangToggleHTML();
    html += `
      <div class="mpf-step">
        <h2 class="mpf-title">${q.text}</h2>
    `;

    if (q.infoImages && Array.isArray(q.infoImages) && q.infoImages.length) {
      html += `
        <div class="mpf-info-images">
          ${q.infoImages
            .map((src) => `<img src="${src}" class="mpf-info-img" />`)
            .join("")}
        </div>
      `;
    }

    html += `<div class="mpf-options">`;

    q.options.forEach((opt) => {
      const cls = opt.primary ? "mpf-option mpf-option-primary" : "mpf-option";
      let label = opt.label;

      // Preis-Anzeige bei Extra-Fragen
      if (id === "q_add_fisheye" && opt.id === "fisheye_yes") {
        const p = getProduct("fisheye_0-25x_37mm");
        if (p && typeof p.price_cents === "number") {
          label += " (+" + formatMoneyFromCents(p.price_cents) + ")";
        }
      }
      if (id === "q_add_microsd" && opt.id === "microsd_yes") {
        const p = getProduct("microsd_32gb");
        if (p && typeof p.price_cents === "number") {
          label += " (+" + formatMoneyFromCents(p.price_cents) + ")";
        }
      }
      if (id === "q_add_hardcase" && opt.id === "hardcase_yes") {
        const p = getProduct("mebblo_camcorder_hard-case_01");
        if (p && typeof p.price_cents === "number") {
          label += " (+" + formatMoneyFromCents(p.price_cents) + ")";
        }
      }

      html += `
        <button class="${cls}" data-next="${opt.next}" data-id="${opt.id}">
          <span>${label}</span>
          ${opt.image ? `<img src="${opt.image}" class="mpf-option-img"/>` : ""}
          ${opt.info ? `<div class="mpf-info">${opt.info}</div>` : ""}
        </button>
      `;
    });

    html += `</div>`;

    if (App.state.history.length > 0) {
      html += `
        <div class="mpf-actions">
          <button class="mpf-back">${currentLang === "de" ? "Zurück" : "Back"}</button>
          <button class="mpf-restart">${currentLang === "de" ? "Guide neu starten" : "Restart guide"}</button>
        </div>
      `;
    } else {
      html += `
        <div class="mpf-actions">
          <button class="mpf-restart">${currentLang === "de" ? "Guide neu starten" : "Restart guide"}</button>
        </div>
      `;
    }

    html += `</div>`;

    App.el.innerHTML = html;

    attachLangEvents();
    attachQuestionEvents();
  }

  function attachLangEvents() {
    const buttons = App.el.querySelectorAll(".mpf-lang-btn");
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const lang = btn.dataset.lang;
        if (!lang || lang === currentLang) return;
        currentLang = lang;

        App.state = {
          step: getFlow().start,
          answers: {},
          history: [],
          mountColor: null,
          fisheye: false,
          microsd: false,
          hardCase: false,
          baseTotalCents: 0,
          fisheyePriceCents: 0,
          microsdPriceCents: 0,
          hardCasePriceCents: 0,
        };
        renderQuestion(getFlow().start);
      });
    });
  }

  function attachQuestionEvents() {
    document.querySelectorAll(".mpf-option").forEach((btn) => {
      btn.addEventListener("click", () => {
        const flow = getFlow();
        const qid = App.state.step;
        const optId = btn.dataset.id;
        const next = btn.dataset.next;

        App.state.answers[qid] = optId;
        App.state.history.push(qid);

        if (qid === "q_add_fisheye") App.state.fisheye = optId === "fisheye_yes";
        if (qid === "q_add_microsd") App.state.microsd = optId === "microsd_yes";
        if (qid === "q_add_hardcase") App.state.hardCase = optId === "hardcase_yes";

        App.state.step = next;
        if (flow.questions[next]) renderQuestion(next);
        else renderResult();
      });
    });

    const back = document.querySelector(".mpf-back");
    if (back) {
      back.addEventListener("click", () => {
        const prev = App.state.history.pop();
        App.state.step = prev;
        renderQuestion(prev);
      });
    }

    const restart = document.querySelector(".mpf-restart");
    if (restart) {
      restart.addEventListener("click", () => {
        App.state = {
          step: getFlow().start,
          answers: {},
          history: [],
          mountColor: null,
          fisheye: false,
          microsd: false,
          hardCase: false,
          baseTotalCents: 0,
          fisheyePriceCents: 0,
          microsdPriceCents: 0,
          hardCasePriceCents: 0,
        };
        renderQuestion(getFlow().start);
      });
    }
  }

  // -------------------------------------------------------
  // OUTCOME ENGINE
  // -------------------------------------------------------

  function getOutcome() {
    const flow = getFlow();
    const tags = [];

    Object.entries(App.state.answers).forEach(([qid, optId]) => {
      const q = flow.questions[qid];
      if (!q) return;
      const o = q.options.find((x) => x.id === optId);
      if (o && o.tags) tags.push(...o.tags);
    });

    if (tags.includes("anschluss_unbekannt")) return flow.unknownConnectionOutcome;

    if (
      tags.includes("anschluss_cinch2") ||
      tags.includes("anschluss_cinch3") ||
      tags.includes("anschluss_svideo") ||
      tags.includes("anschluss_sony10")
    ) {
      return flow.unsupportedConnectionOutcome;
    }

    if (tags.includes("tape_no")) return flow.noTapeOutcome;

    for (const oc of flow.outcomes) {
      if (oc.when && oc.when.hasAll) {
        const needed = oc.when.hasAll;
        if (needed.every((t) => tags.includes(t))) return oc;
      }
    }

    return flow.fallback;
  }

  function attachColorEvents() {
    const btns = document.querySelectorAll(".mpf-color-option");
    if (!btns.length) return;
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const label = btn.dataset.label;
        App.state.mountColor = label;
        btns.forEach((b) => b.classList.toggle("selected", b === btn));
      });
    });
  }

  function recalcPricing() {
    const base = App.state.baseTotalCents || 0;

    const fisheyeAdd =
      App.state.fisheye && App.state.fisheyePriceCents ? App.state.fisheyePriceCents : 0;
    const microsdAdd =
      App.state.microsd && App.state.microsdPriceCents ? App.state.microsdPriceCents : 0;
    const hardAdd =
      App.state.hardCase && App.state.hardCasePriceCents ? App.state.hardCasePriceCents : 0;

    const extras = fisheyeAdd + microsdAdd + hardAdd;
    const finalTotal = base + extras;

    const baseEl = document.getElementById("mpf-base-sum");
    const extrasEl = document.getElementById("mpf-extras-amount");
    const finalEl = document.getElementById("mpf-final-total");

    if (baseEl) baseEl.textContent = formatMoneyFromCents(base);
    if (extrasEl) extrasEl.textContent = formatMoneyFromCents(extras);
    if (finalEl) finalEl.textContent = formatMoneyFromCents(finalTotal);
  }

  function attachFinalAddonEvents() {
    const fisheyeCb = document.getElementById("mpf-extra-fisheye");
    const microsdCb = document.getElementById("mpf-extra-microsd");
    const hardCaseCb = document.getElementById("mpf-extra-hardcase");

    if (fisheyeCb) {
      fisheyeCb.checked = !!App.state.fisheye;
      fisheyeCb.addEventListener("change", () => {
        App.state.fisheye = fisheyeCb.checked;
        recalcPricing();
      });
    }
    if (microsdCb) {
      microsdCb.checked = !!App.state.microsd;
      microsdCb.addEventListener("change", () => {
        App.state.microsd = microsdCb.checked;
        recalcPricing();
      });
    }
    if (hardCaseCb) {
      hardCaseCb.checked = !!App.state.hardCase;
      hardCaseCb.addEventListener("change", () => {
        App.state.hardCase = hardCaseCb.checked;
        recalcPricing();
      });
    }
  }

  function renderResult() {
    const outcome = getOutcome();
    const outcomeProducts = outcome.products || [];

    const mountKeys = [
      "immersionrc_mount_cold-shoe",
      "extension_bracket_generic",
      "minidvr_mount_cold-shoe",
    ];
    const hasMount = outcomeProducts.some((p) => mountKeys.includes(p.key));

    let html = makeLangToggleHTML();
    html += `
      <div class="mpf-result">
        <h2 class="mpf-title">${outcome.title}</h2>
        <div class="mpf-note">${outcome.note}</div>
    `;

    if (hasMount) {
      const colorTitle =
        currentLang === "de" ? "Welche Farbe soll dein Mount haben?" : "Which color should your mount be?";

      html += `
        <div class="mpf-color-block">
          <div class="mpf-color-title">${colorTitle}</div>
          <div class="mpf-color-options">
      `;
      MOUNT_COLORS.forEach((c) => {
        const label = currentLang === "de" ? c.labelDe : c.labelEn;
        const selected = App.state.mountColor === label;
        html += `
          <button
            class="mpf-color-option ${selected ? "selected" : ""}"
            data-color-key="${c.key}"
            data-label="${label}"
            style="--pill-color:${c.hex};"
          >
            ${label}
          </button>
        `;
      });
      html += `
          </div>
        </div>
      `;
    }

    // Produkte
    let baseTotalCents = 0;

    if (outcomeProducts.length > 0) {
      html += `<div class="mpf-products">`;

      outcomeProducts.forEach((item) => {
        const product = getProduct(item.key);
        if (!product) {
          console.warn("[MPF] Produkt nicht gefunden für Key:", item.key);
          return;
        }

        const priceCents = typeof product.price_cents === "number" ? product.price_cents : 0;
        baseTotalCents += priceCents * item.qty;

        html += `
          <div class="mpf-product">
            <img src="${product.image}" class="mpf-product-img"/>
            <div class="mpf-product-info">
              <div class="mpf-product-title">${product.title}</div>
              <div class="mpf-product-price">${formatMoneyFromCents(priceCents)}</div>
            </div>
          </div>
        `;
      });

      html += `</div>`;
    }

    // Extra-Produkte
    const fisheyeProduct = getProduct("fisheye_0-25x_37mm");
    const microsdProduct = getProduct("microsd_32gb");
    const hardCaseProduct = getProduct("mebblo_camcorder_hard-case_01");

    App.state.fisheyePriceCents =
      fisheyeProduct && typeof fisheyeProduct.price_cents === "number" ? fisheyeProduct.price_cents : 0;

    App.state.microsdPriceCents =
      microsdProduct && typeof microsdProduct.price_cents === "number" ? microsdProduct.price_cents : 0;

    App.state.hardCasePriceCents =
      hardCaseProduct && typeof hardCaseProduct.price_cents === "number" ? hardCaseProduct.price_cents : 0;

    App.state.baseTotalCents = baseTotalCents;

    // Extras-Block mit Checkboxes
    if (fisheyeProduct || microsdProduct || hardCaseProduct) {
      const heading =
        currentLang === "de"
          ? "Extras für dein Set (hier kannst du sie noch an- oder abwählen)"
          : "Extras for your set (you can still toggle them here)";

      html += `
        <div class="mpf-addon-block">
          <div class="mpf-addon-heading">${heading}</div>
      `;

      if (fisheyeProduct) {
        const label =
          currentLang === "de"
            ? "Fisheye 0,25x für 37 mm Filtergewinde"
            : "Fisheye 0.25x for 37 mm filter thread";
        html += `
          <label class="mpf-addon-row">
            <input type="checkbox" id="mpf-extra-fisheye" />
            <span>${label} ( +${formatMoneyFromCents(App.state.fisheyePriceCents)} )</span>
          </label>
        `;
      }

      if (microsdProduct) {
        const label = currentLang === "de" ? "microSD-Karte 32 GB" : "microSD card 32 GB";
        html += `
          <label class="mpf-addon-row">
            <input type="checkbox" id="mpf-extra-microsd" />
            <span>${label} ( +${formatMoneyFromCents(App.state.microsdPriceCents)} )</span>
          </label>
        `;
      }

      if (hardCaseProduct) {
        const label =
          currentLang === "de" ? "Hard Case für dein Camcorder-Setup" : "Hard case for your camcorder setup";
        html += `
          <label class="mpf-addon-row">
            <input type="checkbox" id="mpf-extra-hardcase" />
            <span>${label} ( +${formatMoneyFromCents(App.state.hardCasePriceCents)} )</span>
          </label>
        `;
      }

      html += `</div>`;
    }

    // Initiale Summen
    const extrasInit =
      (App.state.fisheye ? App.state.fisheyePriceCents : 0) +
      (App.state.microsd ? App.state.microsdPriceCents : 0) +
      (App.state.hardCase ? App.state.hardCasePriceCents : 0);

    const finalTotalInit = baseTotalCents + extrasInit;

    if (baseTotalCents > 0) {
      html += `
        <div class="mpf-pricing">
          <div>
            ${currentLang === "de" ? "Summe einzelner Produkte (ohne Extras)" : "Sum of individual items (without extras)"}:
            <span id="mpf-base-sum">${formatMoneyFromCents(baseTotalCents)}</span>
          </div>
          ${
            fisheyeProduct || microsdProduct || hardCaseProduct
              ? `<div>
                  ${currentLang === "de" ? "Gewählte Extras" : "Selected extras"}:
                  <span id="mpf-extras-amount">${formatMoneyFromCents(extrasInit)}</span>
                </div>`
              : ""
          }
          <div class="mpf-final">
            ${currentLang === "de" ? "Gesamtpreis (inkl. gewählter Extras)" : "Total (incl. selected extras)"}:
            <span id="mpf-final-total">${formatMoneyFromCents(finalTotalInit)}</span>
          </div>
        </div>

        <button id="mpf-addcart" class="mpf-addcart">
          ${currentLang === "de" ? "Set in den Warenkorb" : "Add bundle to cart"}
        </button>
      `;
    }

    html += `
      <button class="mpf-restart result-restart">
        ${currentLang === "de" ? "Guide neu starten" : "Restart guide"}
      </button>
    </div>
    `;

    App.el.innerHTML = html;

    attachLangEvents();
    attachColorEvents();
    attachFinalAddonEvents();
    recalcPricing();

    const addBtn = document.querySelector("#mpf-addcart");
    if (addBtn && outcomeProducts.length > 0) {
      addBtn.addEventListener("click", async () => {
        if (hasMount && !App.state.mountColor) {
          alert(
            currentLang === "de"
              ? "Bitte wähle zuerst eine Mount-Farbe aus."
              : "Please choose a mount color first."
          );
          return;
        }

        const items = [];

        // Bundle-Produkte
        outcomeProducts.forEach((p) => {
          const product = getProduct(p.key);
          if (!product) {
            console.warn("[MPF] Produkt nicht gefunden für Warenkorb-Key:", p.key);
            return;
          }

          const item = { id: product.id, quantity: p.qty };

          if (mountKeys.includes(p.key) && App.state.mountColor) {
            item.properties = { "Mount-Farbe": App.state.mountColor };
          }

          items.push(item);
        });

        // Extras
        const fisheyeProduct = getProduct("fisheye_0-25x_37mm");
        const microsdProduct = getProduct("microsd_32gb");
        const hardCaseProduct = getProduct("mebblo_camcorder_hard-case_01");

        if (App.state.fisheye && fisheyeProduct) items.push({ id: fisheyeProduct.id, quantity: 1 });
        if (App.state.microsd && microsdProduct) items.push({ id: microsdProduct.id, quantity: 1 });
        if (App.state.hardCase && hardCaseProduct) items.push({ id: hardCaseProduct.id, quantity: 1 });

        if (!items.length) return;

        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items }),
        });

        // KEIN Discount-Code – direkter Cart-Redirect
        window.location.href = "/cart";
      });
    }

    const restart = document.querySelector(".mpf-restart");
    if (restart) {
      restart.addEventListener("click", () => {
        App.state = {
          step: getFlow().start,
          answers: {},
          history: [],
          mountColor: null,
          fisheye: false,
          microsd: false,
          hardCase: false,
          baseTotalCents: 0,
          fisheyePriceCents: 0,
          microsdPriceCents: 0,
          hardCasePriceCents: 0,
        };
        renderQuestion(getFlow().start);
      });
    }
  }

  // -------------------------------------------------------
  // INIT
  // -------------------------------------------------------

  function boot() {
    injectStylesOnce();

    document.querySelectorAll(".mpf-app").forEach((node) => {
      App.el = node;
      App.sectionId = node.dataset.sectionId;
      App.state = {
        step: getFlow().start,
        answers: {},
        history: [],
        mountColor: null,
        fisheye: false,
        microsd: false,
        hardCase: false,
        baseTotalCents: 0,
        fisheyePriceCents: 0,
        microsdPriceCents: 0,
        hardCasePriceCents: 0,
      };
      renderQuestion(getFlow().start);
    });
  }

  document.addEventListener("DOMContentLoaded", boot);
})();